/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable max-len */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable import/extensions */
import React, { Component } from 'react';

import Header from 'parts/Header';
import Footer from 'parts/Footer';

import { ORG_NAME, ORG_EMAIL } from '../constants';

export default class PrivacyPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <>
        <Header />
        <main id="main">
        <section className="container mx-auto px-4 md:px-12 py-16 lg:py-24">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl md:text-5xl lg:text-6xl text-theme-blue font-serif font-bold leading-tight mb-8">
              Privacy Policy
            </h1>
            <div className="text-lg text-gray-500 font-light leading-relaxed space-y-6">
              <p>
                {ORG_NAME} (&ldquo;we&rdquo;, &ldquo;us&rdquo;) respects the privacy of every visitor, family, mentor, and donor we work with. This policy explains what information we collect when you use this website or contact us, and how we use it.
              </p>

              <h2 className="text-2xl font-serif font-semibold text-theme-blue mt-8 mb-4">1. Information we collect</h2>
              <p>
                If you reach out to us through the contact form, by email, or by mail, we may receive your name, email address, the role you selected (volunteer, mentor, parent, partner, donor, other), and the contents of your message. We collect this information because you choose to share it so we can respond.
              </p>
              <p>
                Like most websites, our hosting provider records standard log data such as IP address, browser type, and timestamps. We use this data only to operate, secure, and improve the site.
              </p>

              <h2 className="text-2xl font-serif font-semibold text-theme-blue mt-8 mb-4">2. How we use your information</h2>
              <p>
                We use the information you share with us to: respond to your inquiry, coordinate program enrollment or volunteer onboarding, process donations, send you updates if you have opted in, and operate this website. We do not sell or rent your personal information.
              </p>

              <h2 className="text-2xl font-serif font-semibold text-theme-blue mt-8 mb-4">3. Youth privacy</h2>
              <p>
                We are especially careful with information about young people who participate in our programs. We collect the minimum needed to enroll, communicate with families, and ensure a safe environment. Photos or stories of youth are only published with written consent from a parent or guardian.
              </p>

              <h2 className="text-2xl font-serif font-semibold text-theme-blue mt-8 mb-4">4. Service providers</h2>
              <p>
                We use third-party services to operate the website and our communications, including hosting (Cloudflare) and contact form delivery (EmailJS). These providers may process your data on our behalf under their own privacy practices.
              </p>

              <h2 className="text-2xl font-serif font-semibold text-theme-blue mt-8 mb-4">5. Your choices</h2>
              <p>
                You may ask us to update or delete any personal information you have shared with us by emailing{' '}
                <a href={`mailto:${ORG_EMAIL}`} className="text-theme-purple hover:underline">{ORG_EMAIL}</a>
                . We will respond within a reasonable time.
              </p>

              <h2 className="text-2xl font-serif font-semibold text-theme-blue mt-8 mb-4">6. Updates to this policy</h2>
              <p>
                We may update this policy from time to time. The current version is always posted on this page with the date of last update.
              </p>

              <p className="mt-8 text-sm">
                Last updated: {new Date().toLocaleDateString()}
              </p>
            </div>
          </div>
        </section>
        </main>
        <Footer />
      </>
    );
  }
}
